import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OrganizationStateService } from '../services/organization-state.service';

export const OrganizationInterceptor: HttpInterceptorFn = (req, next) => {

  const organizationState = inject(OrganizationStateService);
  const organizationId = organizationState.currentOrganizationId;

  if (organizationId) {
    const modifiedReq = req.clone({
      setHeaders: {
        'X-Organization-Id': organizationId
      }
    });

    console.log('OrganizationInterceptor: Setting X-Organization-Id header to:', organizationId);
    return next(modifiedReq);
  }

  return next(req);
};
